// First-party
import { createPage } from '@/common/util/templateHelpers';

// Component lib
import { Meta } from '@/common/components/head';

// Local
import { Block, Content, Title, RouterLink } from '@/common/components';
import AboutPageLayout from '@/layouts/AboutPageLayout';
import { faAudioDescription } from '@fortawesome/free-solid-svg-icons';

export default createPage('AdvertisersPage', {}, function AdvertisersPage ({ className }) {
  const description = 'The often imitated, never duplicated Addicting Games brings new games to the masses every week and has been doing this from.. well the start of the internet almost! It&#039;s a wild place to gorge on simple, funny games and find great fodder to share with friends. We have tons of fun and creative ways to reach gamers without annoying them and ensuring your brand/creatives are well';
  const metaProps = {
    description: description,
    openGraph: {
      url: process.env.APP_CONFIG.URL + '/advertisers',
      description: 'The often imitated, never duplicated Addicting Games brings new games to the masses every week and has been doing this from.. well the start of the internet almost! It&#039;s a wild place to gorge on simple, funny games and find great fodder to share with friends. We have tons of fun and creative ways to reach gamers without annoying them and ensuring your brand/creatives are well placed and well received by our players.',
      updated_time: '2021-10-05T12:25:10-07:00',
      'article:published_time': '2021-10-05T12:24:11-07:00',
      'article:modified_time': '2021-10-05T12:25:10-07:00',
    },
    twitter: {
      description: 'The often imitated, never duplicated Addicting Games brings new games to the masses every week and has been doing this from.. well the start of the internet almost! It&#039;s a wild place to gorge on'
    }
  };

  return (
    <AboutPageLayout className={className}>
      <Meta 
        titleTag='Advertising Opportunities | Addicting Games'
        title='Advertising Opportunities' 
        {...metaProps}
      />

      <Block>
        <Title>Advertising Opportunities</Title>

        <Content>
          <p>
          The often imitated, never duplicated Addicting Games brings new games to the masses every week and has been doing this from.. well the start of the internet almost! It's a wild place to gorge on simple, funny games and find great fodder to share with friends. We have tons of fun and creative ways to reach gamers without annoying them and ensuring your brand/creatives are well placed and well received by our players.
          </p>

          <p>
          For inquiries, please contact us here <RouterLink 
              href='https://addictinggameshelp.zendesk.com/hc/en-us/requests/new' 
              target='_blank'
            >
              at our zendesk link
            </RouterLink>, or directly at advertising@addictinggames.com</p>
        </Content>
      </Block>
    </AboutPageLayout>
  );
});